<template>
  <div class="tlqn-circular-progress">
    <q-circular-progress
      :show-value="false"
      :value="_p"
      :size="size"
      color="primary"
      track-color="transparent"
      :thickness="0.5"
      :style="{
        boxShadow: `inset 0 0 calc(${thickness} / 2) rgba(255,255,255,1)`,
        borderRadius: '50%',
      }"
    />
    <!-- <div
      class="tlqn-circular-progress-label"
      :style="{
        width: `calc(100% - ${thickness}*2)`,
        height: `calc(100% - ${thickness}*2)`,
      }"
    >
      {{ _p }}
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 40,
    },

    thickness: {
      type: String,
      default: "10px",
    },

    size: {
      type: String,
      default: "60px",
    },
  },

  mounted() {
    this.$nextTick(() => {
      const defs = document.createElement("defs");
      defs.innerHTML = `
      <linearGradient id="paint0_linear" gradientUnits="userSpaceOnUse" x1="41.5596" y1="1.64209" x2="127.503" y2="49.169" gradientUnits="userSpaceOnUse">
      <stop stop-color="#DD6A3E"/>
      <stop offset="0.8125" stop-color="#EFB9A5" stop-opacity="0.46875"/>
      <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
     `;

      this.$el.querySelector("svg").appendChild(defs);
      this.$el
        .querySelector("svg circle")
        .setAttribute("stroke", "url(#paint0_linear)");
    });
  },

  data() {
    return {
      _p: 0,
    };
  },

  watch: {
    progress: {
      immediate: true,
      handler(p) {
        this._p = p;
      },
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

.tlqn-circular-progress {
  position: relative;
  background-color: $tailong-purple;
  border-radius: 50%;
}
.tlqn-circular-progress-label {
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
svg circle {
  box-shadow: inset 0px 0px 5px rgba(0, 0, 0, 1);
}
</style>
